import React, {Component, useState} from 'react'
import {
    Card,
    Table,
    Button,
    message, Descriptions,
    Tag, Divider,
    Drawer, Tooltip, List,
    Row, Col, Form, Badge, Select, Modal, Input, Collapse, Radio, InputNumber, Empty, Spin, Space, Alert, Tabs
} from 'antd';
import {
    getPerformanceEvaList,
    savePerformanceEva,
    appointSuperLeader,
    getUserListForDropbox,
    clearLeaderPerformanceRate, clearSelfPerformanceRate, clearPerformanceSuperLeader, returnPublishSubordinateKpi,returnHrPublishSubordinateKpi
} from '../../request'
import html2canvas from 'html2canvas';
import * as Icon from '@ant-design/icons';
import ProcessSteps from "./processSteps"
import {withRouter} from "react-router-dom";
const { Panel } = Collapse;
import IconFont from '../../public/iconfont/iconFont'

import './performance.less'
const  locationQuery = new URLSearchParams(window.location.search)
const iFrameParam = locationQuery.get('iframe')
class PerformanceDetail extends Component {
    performanceRef = React.createRef()
    surveyModal = React.createRef()
    formRef = {}
    state = {
        dataSource:[],
        dicList:{},
        SurveyQaList:[],
        columns:[],
        loading:false,
        visible:false,
        systemItem:{},
        formParam:{
            userId:this.props.id!=0?this.props.id:null,
        },
        total:0,
        formDataParam:{
            name:''
        },
        detailDrawerVisible:false,
        submitParam:{},
        userName:'',
        userList:[],
        superLeaderId:undefined,
        downloadLoading:false,
        currentActiveKey:[],
        tabsItem: [],
        hrReturnState:'',
        returnModalVisible:false
    };
    isFreshJourney = ()=>{
        const currentType = this.state.formParam?.kpiType
        return String(currentType||'') === '1'
    }
    isFifthPeriod = (item)=>{
        // 接口数据里的 periodString 形如“试用期第1月(...)”，用数字部分直接判断
        const name = (item?.periodString || '').replace(/\s+/g,'')
        const digitMatch = name.match(/第(\d+)(?:月|期)/)
        return digitMatch ? Number(digitMatch[1]) === 5 : false
    }
    initTableDataList(){
        this.setState({ loading: true });
        getPerformanceEvaList({...this.state.formParam}).then(res=>{
            this.setState({
                loading: false,
                dataSource:res.list,
                userName:res.currentUserName||''
            })
        })
    }
    initUserList = ()=>{
        getUserListForDropbox({type:0}).
        then(res=>{
            this.setState({
                userList:[...res]
            })
        })
    }
    handlePushFilterValueChange = (changedValues, allValues, index)=>{

        // let param = this.state.dataSource
        // param[index].content = allValues.content
        this.setState({
            submitParam:allValues
        })
        // this.saveValues(0)
    }
    handleBlur = (val,index,from)=>{
        console.log('blur',val,val.currentTarget,val.target)
        this.saveValues(0,index,from)
    }
    saveValues = (state,index,from)=>{
        let param = this.state.dataSource[index]
        let setParam = {...param,...this.state.submitParam}
        return new Promise((resolve, reject) => {
            savePerformanceEva({...setParam,publish:state}).then(res=>{
                this.updateDataSource(res,index)
                message.success(state==1?'保存成功':'已存草稿')
                resolve(res)
                if(from=='score'||state==1){
                    const showSelfRate = !this.isFreshJourney()
                    const superLeaderLabel = this.isFreshJourney() ? '部门leader' : '第二评分人'
                    let content = <div style={{textAlign:'left'}}>
                        {showSelfRate?<><span>自评分数：{res.selfRateSum}</span><br/></>:''}
                        leader评分：{res.leaderRateSum}<br/>
                        {superLeaderLabel}评分：{res.superLeaderRateSum}<br/>
                        总分(不包括360评分)：{res.total4RateSum}<br/>
                        最终总分：{res.totalRateSum}
                    </div>
                    message.success(content,5)
                }
                if(state==1){
                    this.setState({
                        submitParam:{}
                    })
                    this.initTableDataList()

                }

            }).catch(err=>{
                resolve()
            })
        })

    }
    downloadValues = async(item)=>{
        await this.setState({
            downloadLoading:true
        })
        this.downloadPDF('performance'+item.periodId,this.state.userName+': '+item.periodHeadString)
    }
    downloadPDF = (id,name) => {

        const input = document.getElementById(id); // 假设你要转换的元素有id="content"
        html2canvas(input, { scale: 1 }).then(canvas => {
            let img = canvas.toDataURL("image/jpeg");
            let a = document.createElement('a');
            // 设置下载属性
            a.href = img;
            a.download = name+'.png';

            // 触发下载
            a.click();
            this.setState({
                downloadLoading:false,
            })



        });
    }
    clearLeaderScore = (item,index)=>{
        const superLeaderLabel = this.isFreshJourney() ? '部门leader评分' : '第二评分人评分'
        let modalTitle = `确定要清空leader评分吗？清空leader评分同时也会清除「${superLeaderLabel}」，请谨慎选择！`
        Modal.confirm({
            title:'提示',
            content:modalTitle,
            onOk:()=>{
                clearLeaderPerformanceRate({ userId:item.userId,periodId:item.periodId}).then(res=>{
                    message.success('清除成功')
                    this.formRef['formRef'+index].resetFields()
                    this.setState({
                        submitParam:{},
                    },()=>{
                        this.initTableDataList()
                    })
                    // this.saveValues(0,index).then(()=>{
                    //     // this.initTableDataList()
                    // })

                })
            },
            onCancel:()=>{

            }

        })

    }
    clearLeader = (item,index)=>{
        const superLeaderLabel = this.isFreshJourney() ? '部门leader' : '第二评分人'
        let modalTitle = `确定要删除${superLeaderLabel}？`
        Modal.confirm({
            title:'提示',
            content:modalTitle,
            onOk:()=>{
                clearPerformanceSuperLeader({ userId:item.userId,periodId:item.periodId}).then(res=>{
                    message.success('清除成功')
                    this.formRef['formRef'+index].resetFields()
                    // this.initTableDataList()
                    this.setState({
                        submitParam:{}
                    })
                    this.saveValues(0,index).then(()=>{
                        this.initTableDataList()
                    })


                })
            },
            onCancel:()=>{

            }

        })

    }
    returnPublishValues = (item,index)=>{
        Modal.confirm({
            title: '提示',
            content: '确认要撤回发布吗？',
            onOk: () => {
                returnPublishSubordinateKpi({userId:item.userId,periodId:item.periodId}).then(res => {
                    message.success('撤回成功')
                    this.formRef['formRef'+index].resetFields()
                    // this.initTableDataList()
                    this.setState({
                        submitParam:{}
                    },()=>{
                        this.initTableDataList()
                    })
                })
            },
            onCancel: () => {

            }

        })

    }
    returnHrPublishValues = (item,index)=>{
        this.setState({
            returnModalVisible:true,
            hrReturnState:'',
            currentItem:item,
        })

    }
    handleHrReturnOk = ()=>{
        // 后端 /kpi/hrReEdit 在未传 id 时，要求 userId 携带周期与KPI类型：userId;periodId;kpiType
        // 仅传 userId 会导致 periodId 解析为 null，接口直接返回“参数有误，无法查询到KPI”
        const {userId, periodId, kpiType} = this.state.currentItem || {}
        const kpiUserParam = [userId, periodId, kpiType].filter(v => v !== null && v !== undefined && v !== '').join(';')
        returnHrPublishSubordinateKpi({userId:kpiUserParam,toStatus:this.state.hrReturnState}).then(res => {
            message.success('撤回成功')
            this.setState({
                submitParam:{},
                returnModalVisible:false,
                hrReturnState:'',
                currentItem:{}
            },()=>{
                this.initTableDataList()
            })
        })
    }
    handleHrReturnCancel = ()=>{
        this.setState({
            returnModalVisible:false,
            hrReturnState:'',
            currentItem:{}
        })
    }
    handleHrReturnStateChange = (e)=>{
        console.log(e.target.value)
        this.setState({
            hrReturnState:Number(e.target.value)
        })
    }
    mergeCells = (text, data, columns) => {
        let i = 0
        if (text !== temp[columns]){
        temp[columns] = text
        data.forEach(((item) => {
            if (item[columns] === temp[columns]){
                i += 1
            }
            }))
        }
        return i
    }

    initTableColumns = (listRecord,listIndex)=>{
        console.log('initTableColumns')
        const isFreshJourney = this.isFreshJourney()
        const showSelfRate = !isFreshJourney
        
        // 解析直属leader的百分比和名字
        const leaderRatePercent = listRecord.leaderRatePercent || ''
        let leaderName = ''
        let leaderPercent = ''
        if (leaderRatePercent) {
            const match = leaderRatePercent.match(/^(\d+%)\s*(.*)$/)
            if (match) {
                leaderPercent = match[1]  // 百分比部分
                leaderName = match[2]      // 名字部分
            } else {
                leaderPercent = leaderRatePercent
            }
        }
        
        const superLeaderPercent = listRecord.superLeaderRatePercent || '0%'
        let publicCol = {
            ...(showSelfRate?{selfRate:<span>员工自评<br/>({listRecord.selfRatePercent||'-'})</span>}:{})
            ,
            leaderRate:<span>直属leader<br/>{leaderName?<>{leaderName}<br/></>:''}({leaderPercent})</span>,
            superLeaderRate:<span>{this.isFreshJourney() ? '部门leader' : '第二评分人'}<br/>{listRecord.superLeaderName?<>{listRecord.superLeaderName}<br/></>:''}({superLeaderPercent})</span>
        }
        let col1 = {
            project:'考核项目1',
            kpiContentString:'考核内容',
            result:<span>实际达成情况<br/>（避免概述，须有案例或数据支撑）</span>,
            kpiEvaluateStandardString:'评价标准'
        }
        let col2 = {
            project:'考核项目2',
            type:'考核维度',
            selfContent:'参考评价标准要求员工填写相应内容',
            standard:'评价标准'
        }
        let col3 = {
            project:'考核项目3',
            person:'评估人',
            suggest:'定性建议',
            score:'定量得分'
        }
        //动态合并单元格
        let setKpiList = {};
        let setKpiList1 = {0:0};
        let kpiCList = listRecord.kpiContents||[]
        kpiCList.map((kpiItem,kpiIndex)=>{
            if(setKpiList.hasOwnProperty(kpiItem.contentGroup)){
                setKpiList[kpiItem.contentGroup].push(kpiIndex)
            }else{
                setKpiList[kpiItem.contentGroup] = [kpiIndex]
            }
        })
        Object.values(setKpiList).map(item=>{
            setKpiList1[item[0]] = item.length
        })
        let col1Set = {...col1,...publicCol}
        let column1 = Object.keys(col1Set).map(item=> {
            let initObj = {
                title: col1Set[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if(item=='project'){
                return {
                    ...initObj,
                    width:'100px',
                    onCell:(_,index)=>{
                        if(setKpiList1.hasOwnProperty(index)){
                            return {rowSpan:setKpiList1[index]}
                        }else{
                            return {rowSpan:0}
                        }
                    },
                    render:(text,record,index)=>{
                        return record.record.contentGroup
                    }
                }
            }else if(item=='kpiContentString'){
                return {
                    ...initObj,
                    width:'220px',
                    render:(text,record,index)=>{
                        return record.record?record.record.kpiContentString:''
                    }
                }
            }else if(item=='kpiEvaluateStandardString'){
                return {
                    ...initObj,
                    align:'left',
                    render:(text, record, index)=>{
                        let info = record.record.kpiEvaluateStandardString

                        let list = info?info.split('\n'):[]
                        let scoreLevel = {
                            0:'red',
                            1:'pink',
                            2:'gold',
                            3:'blue',
                            4:'green',
                        }
                        return (
                            <>
                                {
                                    list.map((item1,index1)=>{
                                        return <div key={index1}>
                                            <Badge status={scoreLevel[index1]} text={
                                                <span style={{fontSize:'12px'}}>{item1}</span>
                                            } />
                                            <Divider style={{margin:'3px 0'}} dashed />
                                        </div>
                                    })
                                }
                            </>
                        )
                    }
                }
            }else if(item=='selfRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                {/*<Form.Item hidden name={'periodId'}></Form.Item>*/}
                                {/*<Form.Item hidden name={'userId'}></Form.Item>*/}
                                <Form.Item name={[record.name,'kpiSelfRate']}>
                                    <InputNumber parser={value => {return `${value>listRecord.kpiFullScore?listRecord.kpiFullScore:value}`}} onBlur={(val)=>this.handleBlur(val,listIndex,'score')} disabled={!listRecord.selfEdit} style={{width:'100%'}} min={0} max={listRecord.kpiFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='leaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={[record.name,'kpiLeaderRate']}>
                                    <InputNumber parser={value => {return `${value>listRecord.kpiFullScore?listRecord.kpiFullScore:value}`}} onBlur={(val)=>this.handleBlur(val,listIndex,'score')} disabled={!listRecord.leaderEdit} style={{width:'100%'}} min={0} max={listRecord.kpiFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='superLeaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={[record.name,'kpiSuperLeaderRate']}>
                                    <InputNumber parser={value => {return `${value>listRecord.kpiFullScore?listRecord.kpiFullScore:value}`}} onBlur={(val)=>this.handleBlur(val,listIndex,'score')} disabled={listRecord.superLeaderShow==1&&listRecord.superLeaderEdit?false:true} style={{width:'100%'}} min={0} max={listRecord.kpiFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='result'){
                return {
                    ...initObj,
                    width:'280px',
                    render:(text, record, index)=>{
                        console.log('record12',record,listRecord)
                        return (
                            <>
                                {
                                    this.state.downloadLoading?
                                        <div className={!listRecord.selfEdit?'text-area-div disabled':'text-area-div'} dangerouslySetInnerHTML={{ __html: (record.record.kpiSelfContent||'').replace(/(\n|\r|\r\n)/g, '<br />') }} /> // 核心代码 drawDescribe.replace(/(\n|\r|\r\n)/g, '<br />')
                                        :
                                        <Form.Item name={[record.name,'kpiSelfContent']}>
                                            <Input.TextArea onBlur={(val)=>this.handleBlur(val,listIndex)} autoSize disabled={!listRecord.selfEdit} />
                                        </Form.Item>
                                }
                            </>
                        )
                    }
                }
            }else{
                return initObj
            }

        })
        let col2Set = {...col2,...publicCol}
        let column2 = Object.keys(col2Set).map(item=> {
            let initObj = {
                title: col2Set[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if(item=='project'){
                return {
                    ...initObj,
                    width:'100px',
                    onCell:(_,index)=>{
                        if(index===0){
                            return {rowSpan:7}
                        }else{
                            return {rowSpan:0}
                        }},
                    render:()=>{
                        return listRecord.valuesTypeString
                    }
                }
            }else if(item=='type'){
                return {
                    ...initObj,
                    width:'220px',
                    render:(text,record,index)=>{
                        return record.record.type
                    }
                }
            }else if(item=='selfContent'){

                return {
                    ...initObj,
                    width:'280px',
                    render:(text, record, index)=> {
                        return (
                            <>
                                <Form.Item hidden name={[record.name, 'id']}>
                                </Form.Item>
                                {
                                    this.state.downloadLoading?
                                        <div className={!listRecord.selfEdit?'text-area-div disabled':'text-area-div'} dangerouslySetInnerHTML={{ __html: (record.record.selfContent||'').replace(/(\n|\r|\r\n)/g, '<br />') }} /> // 核心代码 drawDescribe.replace(/(\n|\r|\r\n)/g, '<br />')
                                        :
                                        <Form.Item name={[record.name, 'selfContent']}>
                                            <Input.TextArea className={'text-area-div'} style={{whiteSpace: 'pre-line'}}
                                                            onBlur={(val) => {
                                                                this.handleBlur(val, listIndex)
                                                            }} autoSize disabled={!listRecord.selfEdit}/>
                                        </Form.Item>
                                }

                            </>

                        )
                    }
                }
            }else if(item=='standard'){
                return {
                    ...initObj,
                    align:'left',
                    render:(text, record, index)=>{
                        let info = record.record.standard
                        let list = info?info.split('\n'):[]
                        let scoreLevel = {
                            0:'red',
                            1:'pink',
                            2:'gold',
                            3:'blue',
                            4:'green',
                        }
                        return (
                            <div>
                                {
                                    list.map((item1,index1)=>{
                                        return <div key={index1}>
                                            <Badge status={scoreLevel[index1]} text={
                                                <span style={{fontSize:'12px'}}>{item1}</span>
                                            } />
                                            <Divider style={{margin:'3px 0'}} dashed />
                                        </div>
                                    })
                                }
                            </div>
                        )
                    }
                }
            }else if(item=='selfRate'){
                return {
                    ...initObj,
                    width: 80,
                    render: (text, record, index) => {
                        return (
                            <>
                                <Form.Item name={[record.name,'selfRate']}>

                                    <InputNumber parser={value => {return `${value>record.record.valuesFullScore?record.record.valuesFullScore:value}`}} onBlur={(val)=>this.handleBlur(val,listIndex,'score')} disabled={!listRecord.selfEdit} style={{width: '100%'}} step={0.5} min={0}
                                                 max={record.record.valuesFullScore} defaultValue={0}/>
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='leaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={[record.name,'leaderRate']}>

                                    <InputNumber parser={value => {return `${value>record.record.valuesFullScore?record.record.valuesFullScore:value}`}} onBlur={(val)=>this.handleBlur(val,listIndex,'score')} disabled={!listRecord.leaderEdit} style={{width:'100%'}} step={0.5} min={0} max={record.record.valuesFullScore} defaultValue={0} />

                                </Form.Item>
                            </>
                        )
                    }
                }
            }else if(item=='superLeaderRate'){
                return {
                    ...initObj,
                    width:80,
                    render:(text, record, index)=>{
                        return (
                            <>
                                <Form.Item name={[record.name,'superLeaderRate']}>
                                    <InputNumber parser={value => {return `${value>record.record.valuesFullScore?record.record.valuesFullScore:value}`}} onBlur={(val)=>this.handleBlur(val,listIndex,'score')} disabled={listRecord.superLeaderShow==1&&listRecord.superLeaderEdit?false:true} style={{width:'100%'}} step={0.5} min={0} max={record.record.valuesFullScore} defaultValue={0} />
                                </Form.Item>
                            </>
                        )
                    }
                }
            }else{
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        {record[item]}
                    }
                }
            }

        })
        let cellM = (_,index)=>{
            if (index === 1) {
                return { colSpan: 0 };
            }
        }
        let column3 = Object.keys(col3).map(item=> {
            let initObj = {
                title: col3[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if(item=='project'){
                return {
                    ...initObj,
                    width:100
                }
            }else if(item=='person'){
                return {
                    ...initObj,

                    children:[
                        {title:'上级',dataIndex:'leader',width:120,onCell: (_, index) => {
                                if(index==1){
                                    return { colSpan: 4 }
                                }
                            },
                        },
                        {title:'协作伙伴',dataIndex:'peer',width:120,onCell:cellM},
                        {title:'下级伙伴',dataIndex:'down',width: 140,onCell:cellM},
                    ]
                }
            }else if(item=='suggest'){
                return {
                    ...initObj,
                    align: 'left',
                    onCell:cellM,
                    render:(text,record)=>{
                        let arr = text||[]
                        return (
                            <>
                                <List
                                    className={'eval-360-list'}
                                    dataSource={arr}
                                    renderItem={(item1)=>(
                                        <List.Item key={item1.title}>
                                            <List.Item.Meta
                                                title={item1.title}
                                                description={
                                                    <div>
                                                        {item1.answer.map((item2,index2)=>{
                                                            return <div key={index2}>
                                                                <Badge status="processing" />{item2}
                                                            </div>
                                                        })}
                                                    </div>
                                                }
                                            />
                                        </List.Item>
                                    )}
                                />

                            </>
                        )
                    }
                }
            }else if(item=='score'){
                return {
                    ...initObj,width: 240,
                    render:(text,record)=>{
                        const showConverted = record.showConverted
                        const displayScore = showConverted?record.converted360Score:record.score
                        const baseScore = record.raw360Score
                        return (
                            <div style={{textAlign:'left'}}>
                                <div style={{fontWeight:'bold',fontSize:'16px'}}>{displayScore!==undefined?displayScore:'-'}</div>
                                {
                                    showConverted?
                                        <div style={{color:'#8c8c8c',fontSize:'12px',lineHeight:1.6}}>
                                            参考折算分（不计入总分）
                                            <br/>原平均分：{baseScore!==undefined?baseScore:'-'}
                                            <br/>公式：(360平均得分-3)×1.3+3
                                        </div>:
                                        <div style={{color:'#8c8c8c',fontSize:'12px',lineHeight:1.6}}>360平均分</div>
                                }
                            </div>
                        )
                    }
                }
            }else{
                return initObj
            }

        })
        return {
            column1,column2,column3
        }
    }
    initTableDataSource = (record)=>{
        const isFreshJourney = this.isFreshJourney()
        let dataSource1 = [
            ...record.kpiContents?record.kpiContents:[],
        ]
        let dataSource2 = [
            ...record.valuesData?record.valuesData:[],
        ]
        let data360 = record.evalResultVo||{}
        let refUsers = data360.refUsers||{}
        const rawEvalScore = data360.avgScore!=undefined?data360.avgScore:data360.score
        const hasRawEvalScore = rawEvalScore!=undefined && rawEvalScore!=null && rawEvalScore!==''
        const numericEvalScore = Number(rawEvalScore)
        const canConvertEval = !Number.isNaN(numericEvalScore)
        const convertedEvalScore = isFreshJourney && hasRawEvalScore && canConvertEval ? Number(((numericEvalScore - 3) * 1.3 + 3).toFixed(2)) : (hasRawEvalScore?rawEvalScore:undefined)
        let dataSource3 = [
            {
                project:<p style={{whiteSpace:'pre-line'}}>{data360.name}{isFreshJourney?<><br/><Tag color="purple">折算参考分（不计总分）</Tag></>:''}</p>,
                peer:refUsers['协作者']?refUsers['协作者'].join(','):'-',
                down:refUsers['下级']?refUsers['下级'].join(','):'-',
                leader:refUsers['领导']?refUsers['领导'].join(','):'-',
                suggest:data360.suggest,
                score:isFreshJourney?convertedEvalScore:rawEvalScore,
                raw360Score:hasRawEvalScore?rawEvalScore:undefined,
                converted360Score:convertedEvalScore,
                showConverted:isFreshJourney
            },
        ]

        let dataSource4 = [
            {
                title: '【评分合计】考核项目1+2（公式：KPI+价值观七项平均分x5）',
                selfRateSum: record.selfRateSum,
                leaderRateSum: record.leaderRateSum,
                superLeaderRateSum: record.superLeaderRateSum,
            }
        ]
        let dataSource5 = [
            {
                title:'总分',
                subs:record.total3TypeString,
                score:record.totalRateSum
            },
        ]
        let dataSource6 = [
            {
                title:record.coolTitle||'完成情况',
                result:record.coolScoreResult,
                coolComplete:record.coolComplete
            },
        ]
        let dataSource7 = [
            {
                title:'最终总分',
                subs:record.total4TypeString,
                score:record.total4RateSum
            },
        ]
        return {
            dataSource1,dataSource2,dataSource3,dataSource4,dataSource5,dataSource6,dataSource7
        }
    }
    updateDataSource = (record,index)=>{
        let dataSource = [...this.state.dataSource]
        dataSource[index] = {...dataSource[index],...record}
        this.setState(
            {
                dataSource: dataSource
            }
        )
    }
    getPerformanceState = (item)=>{
        let stateObj = {
            1:{
                color:'red',
                icon:'icon-buhege'
            },
            2:{
                color:'#00bcd4',
                icon:'icon-hege1'
            },
            3:{
                color:'green',
                icon:'icon-youxiu6'
            }
        }
        return (
            <span style={{marginLeft:'10px'}}>
                {
                    stateObj[item.scoreGrade]?
                        <IconFont style={{position:'absolute',top:0,fontSize:'44px',color:stateObj[item.scoreGrade].color}} type={stateObj[item.scoreGrade].icon} />:''
                }

            </span>

        )
    }

    addSuperLeader = (item,index)=>{
        appointSuperLeader({
            userId:this.state.formParam.userId,
            periodId:item.periodId,
            superLeaderId:this.state.superLeaderId
        }).then(res=>{
            message.success('添加成功')
            // this.initTableDataList()
            this.saveValues(0,index).then(()=>{
                this.initTableDataList()
            })
        })
    }
    handleCollapseChange = (val)=>{
        this.setState({
            currentActiveKey:val
        })
    }
    handleTabChange = (key) => {
        this.setState({
            formParam: {
                ...this.state.formParam,
                kpiType:key,
            },
            dataSource:[]
        },()=>{
            this.initTableDataList()
        })


    }
    componentDidMount(){
        this.initUserList()
        const  locationQuery = new URLSearchParams(this.props.location.search)
        const initType = locationQuery.get('kpiType')
        let sList = [
            {
                label:'新人之旅',
                key:'1',
            },
            {
                label:'月度',
                key:'2'
            },
        ]
        const tabsItem = initType?sList.filter(item=>item.key==initType):sList
        const kpiType = initType || '1'
        this.setState({
            formParam: {
                ...this.state.formParam,
                kpiType,
            },
            tabsItem:[...tabsItem]
        },()=>{
            this.initTableDataList()
        })


    }
    render() {
        const locationQuery = new URLSearchParams(window.location.search)
        const periodId = locationQuery.get('periodId')||''
        const {dataSource, columns, loading, detailDrawerVisible, dicList, editParam} = this.state;
        const isFreshJourney = this.isFreshJourney()
        const showSelfRate = !isFreshJourney
        const superLeaderLabel = isFreshJourney ? '部门Leader' : '第二评分人'
        return (
            <>
                <Card title={
                    this.props.id?
                        <>
                            {
                                iFrameParam!='iframe'?
                                    <span style={{marginRight:'10px',fontWeight:'bolder',cursor:'pointer'}} onClick={()=>this.props.history.go(-1)}><Icon.ArrowLeftOutlined/></span>
                                    :''
                            }
                            {
                                '考核评估：' + this.state.userName
                            }
                        </>:
                        '考核评估：我的'
                } bordered={false}
                      className={'card-fixed-head-wrap performance-detail-wrap'}>
                    <Tabs
                        onChange={(key)=>this.handleTabChange(key)}
                        type="card"
                        items={this.state.tabsItem}
                    />
                    <Spin spinning={loading}>
                        {
                            this.state.dataSource.length > 0 ?
                                <Collapse onChange={this.handleCollapseChange} defaultActiveKey={[periodId]} expandIconPosition={'end'}>
                                    {
                                        this.state.dataSource.map((item, index) => {
                                            let columnsAll = this.initTableColumns(item,index)
                                            let dataSourceAll = this.initTableDataSource(item)
                                            return (
                                                <Panel style={{position:"relative"}} forceRender collapsible={item.viewable ? 'header' : 'disabled'}
                                                       header={
                                                           <Tooltip title={'当前周期的进度为：'+item.stage} placement={'topLeft'}>

                                                               <div style={{paddingLeft:'90px'}}>
                                                                   <Badge.Ribbon placement={'start'} text={item.stage.split('(')[0]} color="#54a6f1" />
                                                                   {item.periodString}
                                                                   {
                                                                       this.getPerformanceState(item)
                                                                   }
                                                               </div>
                                                           </Tooltip>

                                                       }
                                                       extra={
                                                           <>
                                                               <ProcessSteps steps={item.stageVO}/>

                                                           </>

                                                       }
                                                       key={item.periodId}>

                                                    <Spin spinning={this.state.downloadLoading}>
                                                    <div style={{
                                                        marginBottom: '10px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between'
                                                    }}>
                                                        <div>
                                                            {
                                                                item.showPublishTip ?
                                                                    <span style={{fontSize: '11px',color:'#e50011'}}>
                                                                        <Icon.InfoCircleOutlined/> 当前状态为草稿状态，请记得评估完成后， 点击「发布」
                                                                        </span>
                                                                    : ''
                                                            }
                                                        </div>
                                                        <div>
                                                            <img src={this.state.img}/>
                                                            {
                                                                item.showSuperLeaderSelect ?
                                                                    <>

                                                                        <Select
                                                                            style={{minWidth: '200px'}}
                                                                            showSearch
                                                                            optionFilterProp="children"
                                                                            fieldNames={{
                                                                                label: 'USER_NICK',
                                                                                value: 'USER_ID'
                                                                            }}
                                                                        filterOption={(input, option) => {
                                                                                let searchText = (option?.USER_NICK ?? '') + (option?.pinyin ?? '')
                                                                                return searchText.toLowerCase().includes(input.toLowerCase())
                                                                            }
                                                                            }
                                                                            allowClear
                                                                            placeholder={`请添加${superLeaderLabel}`}
                                                                            options={this.state.userList}
                                                                            onChange={(value, option) => {
                                                                                this.setState({
                                                                                    superLeaderId: value
                                                                                })

                                                                            }}
                                                                        />
                                                                        <Button
                                                                            onClick={() => this.addSuperLeader(item,index)}
                                                                            danger type={'primary'}>添加</Button>
                                                                        <span style={{marginLeft:'10px'}}>
                                                                            <Tooltip title={isFreshJourney ? '请您与【您的直属上级】确认TA是否需要对该员工的试用期考核进行评分，如果需要麻烦指派。' : '如该员工需要第二评分人参与打分，请在此指定。'}>
                                                                                <span style={{color:'green'}}><Icon.InfoCircleOutlined/> 说明</span>
                                                                            </Tooltip>
                                                                        </span>

                                                                    </> : ''
                                                            }

                                                        </div>
                                                        <div>
                                                            <Space>
                                                                {item.showSave ?
                                                                    <Tag  style={{cursor: 'pointer'}}
                                                                          onClick={() => this.saveValues(1,index)}
                                                                          color={'cyan'}>发布</Tag>
                                                                    : ''}
                                                                {item.showHrReEdit ?
                                                                    <Tag  style={{cursor: 'pointer'}}
                                                                          onClick={() => this.returnHrPublishValues(item,index)}
                                                                          color={'blue'}>HR退回</Tag>
                                                                    : ''}
                                                                {item.showReEdit ?
                                                                        <>
                                                                            <Tag style={{cursor: 'pointer'}}
                                                                                 onClick={() => this.returnPublishValues(item,index)}
                                                                                 color={'cyan'}>撤回发布</Tag>
                                                                        </> : ''}
                                                                {item.leaderEdit ?
                                                                    <Tag style={{cursor: 'pointer'}}
                                                                         onClick={() => this.clearLeaderScore(item,index)}
                                                                         color={'red'}>清空Leader评分</Tag>
                                                                    : ''}
                                                                {item.showSuperLeaderClear ?
                                                                    <Tag style={{cursor: 'pointer'}}
                                                                         onClick={() => this.clearLeader(item,index)}
                                                                         color={'pink'}>{`删除${superLeaderLabel}`}</Tag>
                                                                    : ''}

                                                                <Tag style={{cursor: 'pointer'}}
                                                                     onClick={() => this.downloadValues(item)}
                                                                     color={'green'}>导出</Tag>
                                                            </Space>
                                                        </div>
                                                    </div>
                                                    <Form id={'performance' + item.periodId}
                                                          ref={(el)=>this.formRef['formRef'+index] = el}
                                                          className={'performance-form'} initialValues={item}
                                                          onFieldsChange={(changedFields, allFields) => console.log('filedChnage', changedFields, allFields)}
                                                          onValuesChange={(changedValues, allValues) => this.handlePushFilterValueChange(changedValues, allValues, index)}
                                                    >
                                                        {this.state.downloadLoading?item.periodString:''}
                                                        {/*{*/}
                                                        {/*    item.valuesVisible['kpiShow']==1?*/}
                                                        {/*    <Table*/}
                                                        {/*        size={'small'}*/}
                                                        {/*        bordered*/}
                                                        {/*        pagination={false}*/}
                                                        {/*        columns={*/}
                                                        {/*            columnsAll.column1*/}
                                                        {/*        }*/}
                                                        {/*        dataSource={dataSourceAll.dataSource1}*/}
                                                        {/*        rowKey={record=>record.id}*/}
                                                        {/*    />:''*/}
                                                        {/*}*/}
                                                        {
                                                            item.valuesVisible['kpiShow']==1?
                                                                <>
                                                                    <Form.List name={'kpiContents'}>
                                                                        {(fields, operation) => {
                                                                            let newFields = fields.map((field, fIndex) => {
                                                                                field.record = item.kpiContents[fIndex]
                                                                                return field
                                                                            })

                                                                            return <Table
                                                                                size={'small'}
                                                                                bordered
                                                                                pagination={false}
                                                                                columns={
                                                                                    columnsAll.column1
                                                                                }
                                                                                dataSource={newFields}
                                                                                rowKey={record=>record.id}
                                                                            />
                                                                        }}
                                                                    </Form.List>
                                                                    <Table
                                                                        className={'table-score-light'}
                                                                        showHeader={false}
                                                                        size={'small'}
                                                                        bordered
                                                                        pagination={false}
                                                                        columns={
                                                                            [
                                                                                {dataIndex: 'title', title: '总分', align: 'center'},
                                                                                ...(showSelfRate?[{
                                                                                    dataIndex: 'kpiSelfRateSum',
                                                                                    title: '得分',
                                                                                    width: 80,
                                                                                    align: 'center'
                                                                                }]:[]),
                                                                                {
                                                                                    dataIndex: 'kpiLeaderRateSum',
                                                                                    title: '得分',
                                                                                    width: 80,
                                                                                    align: 'center'
                                                                                },
                                                                                {
                                                                                    dataIndex: 'kpiSuperLeaderRateSum',
                                                                                    title: '得分',
                                                                                    width: 80,
                                                                                    align: 'center'
                                                                                },
                                                                            ]
                                                                        }
                                                                        dataSource={
                                                                            [{
                                                                                title:'考核项目1-各项评分',
                                                                                kpiLeaderRateSum: item.rateSumVo.kpiLeaderRateSum||0,
                                                                                kpiSelfRateSum: item.rateSumVo.kpiSelfRateSum||0,
                                                                                kpiSuperLeaderRateSum: item.rateSumVo.kpiSuperLeaderRateSum||0,
                                                                                kpiTotalRateSum: item.rateSumVo.kpiLeaderRateSum||0
                                                                            }]
                                                                        }
                                                                    />
                                                                    <Table
                                                                        className={'table-score'}
                                                                        showHeader={false}
                                                                        size={'small'}
                                                                        bordered
                                                                        pagination={false}
                                                                        columns={
                                                                            [
                                                                                {dataIndex: 'title', title: '总分', align: 'center'},
                                                                                {
                                                                                    dataIndex: 'kpiTotalRateSum',
                                                                                    title: '得分',
                                                                                    width: 240,
                                                                                    align: 'center'
                                                                                },
                                                                            ]
                                                                        }
                                                                        dataSource={
                                                                            [{
                                                                                title:'考核项目1-总分',
                                                                                kpiTotalRateSum: item.rateSumVo.kpiTotalRateSum||0
                                                                            }]
                                                                        }
                                                                    />
                                                                </>
                                                                :''
                                                        }
                                                        {
                                                            item.valuesVisible['valuesShow']==1?
                                                                <>

                                                                    <Form.List name={'valuesData'}>
                                                                        {(fields, operation) => {
                                                                            let newFields = fields.map((field, fIndex) => {
                                                                                field.record = item.valuesData[fIndex]
                                                                                return field
                                                                            })
                                                                            return <Table
                                                                                size={'small'}
                                                                                bordered
                                                                                pagination={false}
                                                                                columns={
                                                                                    columnsAll.column2
                                                                                }
                                                                                dataSource={newFields}
                                                                                rowKey={record=>record.id}
                                                                            />
                                                                        }}
                                                                    </Form.List>
                                                                    <Table
                                                                        className={'table-score-light'}
                                                                        showHeader={false}
                                                                        size={'small'}
                                                                        bordered
                                                                        pagination={false}
                                                                        columns={
                                                                            [
                                                                                {dataIndex: 'title', title: '总分', align: 'center'},
                                                                                ...(showSelfRate?[{
                                                                                    dataIndex: 'valuesSelfRateSum',
                                                                                    title: '得分',
                                                                                    width: 80,
                                                                                    align: 'center'
                                                                                }]:[]),
                                                                                {
                                                                                    dataIndex: 'valuesLeaderRateSum',
                                                                                    title: '得分',
                                                                                    width: 80,
                                                                                    align: 'center'
                                                                                },
                                                                                {
                                                                                    dataIndex: 'valuesSuperLeaderRateSum',
                                                                                    title: '得分',
                                                                                    width: 80,
                                                                                    align: 'center'
                                                                                },
                                                                            ]
                                                                        }
                                                                        dataSource={
                                                                            [{
                                                                                title:'考核项目2-各项评分',
                                                                                valuesLeaderRateSum: item.rateSumVo.valuesLeaderRateSum||0,
                                                                                valuesSelfRateSum: item.rateSumVo.valuesSelfRateSum||0,
                                                                                valuesSuperLeaderRateSum: item.rateSumVo.valuesSuperLeaderRateSum||0,
                                                                                valuesTotalRateSum: item.rateSumVo.valuesLeaderRateSum||0
                                                                            }]
                                                                        }
                                                                    />
                                                                    <Table
                                                                        className={'table-score'}
                                                                        showHeader={false}
                                                                        size={'small'}
                                                                        bordered
                                                                        pagination={false}
                                                                        columns={
                                                                            [
                                                                                {dataIndex: 'title', title: '总分', align: 'center'},
                                                                                {
                                                                                    dataIndex: 'valuesTotalRateSum',
                                                                                    title: '得分',
                                                                                    width: 240,
                                                                                    align: 'center'
                                                                                },
                                                                            ]
                                                                        }
                                                                        dataSource={
                                                                            [{
                                                                                title:'考核项目2-总分',
                                                                                valuesTotalRateSum: item.rateSumVo.valuesTotalRateSum||0
                                                                            }]
                                                                        }
                                                                    />
                                                                </>:''
                                                        }

                                                        {/*{*/}
                                                        {/*    item.valuesVisible['2SumShow']==1?*/}
                                                        {/*    <Table*/}
                                                        {/*        className={'table-score'}*/}
                                                        {/*        showHeader={false}*/}
                                                        {/*        size={'small'}*/}
                                                        {/*        bordered*/}
                                                        {/*        pagination={false}*/}
                                                        {/*        columns={*/}
                                                        {/*            [*/}
                                                        {/*                {dataIndex: 'title', title: '总分', align: 'center'},*/}
                                                        {/*                {*/}
                                                        {/*                    dataIndex: 'selfRateSum',*/}
                                                        {/*                    title: '得分',*/}
                                                        {/*                    width: 80,*/}
                                                        {/*                    align: 'center'*/}
                                                        {/*                },*/}
                                                        {/*                {*/}
                                                        {/*                    dataIndex: 'leaderRateSum',*/}
                                                        {/*                    title: '得分',*/}
                                                        {/*                    width: 80,*/}
                                                        {/*                    align: 'center'*/}
                                                        {/*                },*/}
                                                        {/*                {*/}
                                                        {/*                    dataIndex: 'superLeaderRateSum',*/}
                                                        {/*                    title: '得分',*/}
                                                        {/*                    width: 80,*/}
                                                        {/*                    align: 'center'*/}
                                                        {/*                },*/}
                                                        {/*            ]*/}
                                                        {/*        }*/}
                                                        {/*        dataSource={*/}
                                                        {/*            dataSourceAll.dataSource4*/}
                                                        {/*        }*/}
                                                        {/*    />:''*/}
                                                        {/*}*/}
                                                        {
                                                            item.valuesVisible['3SumShow']==1 && !isFreshJourney?
                                                            <Table
                                                                className={'table-score'}
                                                                showHeader={false}
                                                                size={'small'}
                                                                bordered
                                                                pagination={false}
                                                                columns={
                                                                    [
                                                                        {
                                                                            dataIndex: 'title',
                                                                            title: '总分',
                                                                            width: 100,
                                                                            align: 'center'
                                                                        },
                                                                        {dataIndex: 'subs', title: '描述'},
                                                                        {
                                                                            dataIndex: 'score',
                                                                            title: '得分',
                                                                            width: 240,
                                                                            align: 'center'
                                                                        },
                                                                    ]
                                                                }
                                                                dataSource={
                                                                    dataSourceAll.dataSource5
                                                                }
                                                            />:''
                                                        }
                                                        {
                                                            item.valuesVisible['coolShow']==1?
                                                            <Table
                                                                size={'small'}
                                                                bordered
                                                                pagination={false}
                                                                columns={
                                                                    [
                                                                        {
                                                                            dataIndex: 'title',
                                                                            title: '培训模块',
                                                                            width: 100,
                                                                            align: 'center'
                                                                        },
                                                                        {
                                                                            dataIndex: 'result',
                                                                            title: '当月培训旅程',
                                                                            render: (text, record, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {
                                                                                            (text || []).map((item2,index2) => {
                                                                                                return <div key={index2}><Badge
                                                                                                    status={'processing'}
                                                                                                    text={item2}/></div>
                                                                                            })
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            }
                                                                        },
                                                                        {
                                                                            dataIndex: 'coolComplete',
                                                                            title: '培训得分',
                                                                            width: 240,
                                                                            align: 'center'
                                                                        },
                                                                    ]
                                                                }
                                                                dataSource={dataSourceAll.dataSource6}
                                                            />:''
                                                        }
                                                        {
                                                            item.valuesVisible['4SumShow']==1?
                                                            <Table
                                                                className={'table-score'}
                                                                showHeader={false}
                                                                size={'small'}
                                                                bordered
                                                                pagination={false}
                                                                columns={
                                                                    [
                                                                        {
                                                                            dataIndex: 'title',
                                                                            title: '总分',
                                                                            width: 100,
                                                                            align: 'center'
                                                                        },
                                                                        {dataIndex: 'subs', title: '描述'},
                                                                        {
                                                                            dataIndex: 'score',
                                                                            title: '得分',
                                                                            width: 240,
                                                                            align: 'center',
                                                                            render: (text, record, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {text}
                                                                                        {this.getPerformanceState(item)}
                                                                                    </>

                                                                                )
                                                                            }
                                                                        }
                                                                    ]
                                                                }
                                                                dataSource={
                                                                    dataSourceAll.dataSource7
                                                                }
                                                            />:''
                                                        }
                                                        {
                                                            item.valuesVisible['360Show']==1 && this.isFifthPeriod(item)?
                                                            <Table
                                                                size={'small'}
                                                                bordered
                                                                pagination={false}
                                                                columns={
                                                                    columnsAll.column3
                                                                }
                                                                dataSource={dataSourceAll.dataSource3}
                                                            />:''
                                                        }
                                                    </Form>
                                                    </Spin>
                                                </Panel>
                                            )
                                        })
                                    }
                                </Collapse>
                                :
                                <Empty/>
                        }

                    </Spin>
                    <Modal title={'提示'} open={this.state.returnModalVisible} onOk={this.handleHrReturnOk} onCancel={this.handleHrReturnCancel}>
                        <Alert style={{marginBottom: '20px'}} message="请选择该期绩效评估要退回的进度" type="success" showIcon />

                        {/*可选的：2制定KPI，4确认KPI，5员工自评，7Leader评分，9第二评分人/部门Leader评分*/}
                        <Radio.Group onChange={this.handleHrReturnStateChange} value={this.state.hrReturnState}>}
                            <Space direction="vertical">
                                <Radio value={2}>制定KPI</Radio>
                                <Radio value={4}>确认KPI</Radio>
                                <Radio value={5}>员工自评</Radio>
                                <Radio value={7}>Leader评分</Radio>
                                <Radio value={9}>{this.isFreshJourney() ? '部门Leader评分' : '第二评分人评分'}</Radio>
                            </Space>
                        </Radio.Group>
                    </Modal>
                </Card>
            </>

        )
    }
}
export default withRouter(PerformanceDetail)
